import { memo } from "react";
import { ReactSVG } from "react-svg";
import { ENVIRONMENT_IS_DEVELOPMENT } from "../../../src/util/development";
import { resolveMapAssetUrl } from "@/src/consts/urls";

type Props = {
    asset: string;
    version?: string;
    afterInjection?: (svg: SVGSVGElement) => void;
    beforeInjection?: (svg: SVGSVGElement) => void;
};

export function MapSVGUnmemoized({
    asset,
    version,
    afterInjection,
    beforeInjection,
}: Props): JSX.Element {
    // don't use the CDN for local development, or if it's a blob
    const srcUrl = resolveMapAssetUrl(
        asset,
        version,
        !ENVIRONMENT_IS_DEVELOPMENT,
    );

    return <ReactSVG
        src={srcUrl}
        afterInjection={afterInjection}
        beforeInjection={beforeInjection}
        renumerateIRIElements={false}
    />;
}

export const MapSVGMemoized = memo(
    MapSVGUnmemoized,
    (oldProps: Props, newProps: Props) => {
        return oldProps.asset === newProps.asset
            && oldProps.version === newProps.version;
    },
);
